export const InputStyles = {
  Base:
    "flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm " +
    "outline-none border border-input hover:border-input focus:ring-0 focus:border-blue-500 focus-within:border-blue-500 focus:border-2 focus-within:border-2 !focus:shadow-none " +
    "placeholder:text-muted-foreground " +
    "disabled:cursor-not-allowed disabled:opacity-50 " +
    "transition-colors transition-border duration-200 box-border ",
  Input: "h-9",
  Textarea: "min-h-[60px]",
};
